<template>
  <div class="main-bg app-container">
    <Banner
      :bgImage="bannerInfo.file || bannerImage"
      bgPosition="center center"
      :title="bannerInfo.title"
      :subTitle="bannerInfo.subTitle && bannerInfo.desc ? bannerInfo.subTitle + '\n' + bannerInfo.desc : bannerInfo.title"
    >
      <template #top>
        <div class="wrap">
          <div class="font16 banner-tag" v-if="bannerInfo.tag || bannerInfo.tagIcon">
            <NuxtImg
              format="webp"
              loading="lazy"
              placeholder
              v-if="bannerInfo.tagIcon"
              class="icon"
              :src="bannerInfo.tagIcon"
              alt="icon vip"
            />
            <span class="text MultiLine1">{{ bannerInfo.tag }}</span>
          </div>
        </div>
      </template>
      <template #bottom>
        <div class="wrap">
          <div class="ban-btn btns">
            <div @click="trackDownload(download.ios, 'Weather_APP_page_banner_Download_iOS')" class="btn-default btn">
              <img class="icon" src="@/assets/images/iconSvg/ios.svg" :alt="t('weather.storeDown')" />
              <span class="text">{{ t('weather.storeDown') }}</span>
            </div>
            <div
              @click="trackDownload(download.android, 'Weather_APP_page_banner_Download_Android')"
              class="btn-default btn-hollow btn"
            >
              <img class="icon" src="@/assets/images/iconSvg/android.svg" :alt="t('weather.AndroidDown')" />
              <span class="text">{{ t('weather.AndroidDown') }}</span>
            </div>
          </div>
          <div class="wechat color-f text-center" :class="locale == 'en-US'?'font12':'font16'">
            <ImageBackstop :src="bannerInfo.qrCode" :alt="t('weather.scanDownAlt')" />
            <p>{{ t('weather.scanDown') }}</p>
          </div>
        </div>
      </template>
    </Banner>
    <div class="app-bg app-bg1">
      <div class="wrap">
        <template v-if="JSON.stringify(trustUser) !== '{}'">
          <Ani class="box-title text-center">
            <h2 class="box-h2 font36 color-f">{{ trustUser.title }}</h2>
          </Ani>
          <Ani>
            <ul class="box1-list list-style flex justify-between font16 color-f text-center">
              <li v-for="(item, index) in trustUser && trustUser.dataList" :key="index">
                <div class="box1-num font18 no-wrap">
                  <strong class="font40">{{ item.count }}</strong>
                  {{ item.unit }}
                </div>
                <div class="box1-text">
                  <p>{{ item.title }}</p>
                  <p>{{ item.subTitle }}</p>
                </div>
              </li>
            </ul>
          </Ani>
        </template>
      </div>
    </div>
    <div class="app-bg app-bg2">
      <div class="wrap">
        <template v-if="JSON.stringify(authCert) !== '{}'">
          <Ani class="box-title text-center">
            <h2 class="box-h2 font36 color-f">{{ authCert.title }}</h2>
          </Ani>
          <Ani class="app2-box">
            <ul class="app2-list list-style flex flex-wrap">
              <li v-for="(item, index) in authCert.dataList" :key="index">
                <div class="app2-item">
                  <div class="app2-icon flex-center"><img :src="item.icon" :alt="item.title || ''" /></div>
                  <div class="app2">
                    <h3 class="app2-title font24 color-f MultiLine1">{{ item.title }}</h3>
                    <div class="app2-con font16 color-f">
                      <div class="app2-des MultiLine2">
                        <p>{{ item.subTitle }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </Ani>
        </template>
      </div>
    </div>
    <div class="app-bg app-bg3">
      <div class="wrap">
        <template v-if="JSON.stringify(coreFeature) !== '{}'">
          <Ani class="box-title text-center">
            <h2 class="box-h2 font36 color-f">{{ coreFeature.title }}</h2>
          </Ani>
          <Ani class="app2-box">
            <ul class="app2-list list-style flex flex-wrap">
              <li v-for="(item, index) in coreFeature.dataList" :key="index">
                <div class="app2-item">
                  <div class="app2-icon flex-center"><img :src="item.icon" :alt="item.title || ''" /></div>
                  <div class="app2">
                    <h3 class="app2-title font24 color-f" :class="locale == 'en-US'?'MultiLine2':'ellipsis'">{{ item.title }}</h3>
                    <div class="app2-con font16 color-f MultiLine" :class="locale == 'en-US'?'app3-con':''">
                      <div class="app2-des">
                        <p>{{ item.subTitle }}</p>
                      </div>
                    </div>
                    <div class="app2-light font16 color-m ellipsis">{{ item.tag }}</div>
                  </div>
                </div>
              </li>
            </ul>
          </Ani>
        </template>
      </div>
    </div>
    <div class="app-bg app-bg4">
      <div class="wrap">
        <ul class="app4-list list-style font16">
          <li>
            <template v-if="JSON.stringify(aiCoreTechnology) !== '{}'">
              <Ani class="app4-item flex align-center justify-between">
                <div class="app4-text">
                  <div class="app4-tag font16">
                    <img v-if="aiCoreTechnology.tagIcon" class="icon" :src="aiCoreTechnology.tagIcon" alt="icon" />
                    <span class="text ellipsis">{{ aiCoreTechnology.tag }}</span>
                  </div>
                  <div class="app4-con">
                    <h3 class="app4-title font24" :class="locale == 'en-US'?'':'ellipsis'">{{ aiCoreTechnology.title }}</h3>
                    <div class="app4-info" :class="locale == 'en-US'?'':'MultiLine2'">
                      <div class="app4-des font16">
                        <p>
                          {{ aiCoreTechnology.desc }}
                        </p>
                      </div>
                    </div>
                    <ul class="app4-list1">
                      <li>
                        <p v-for="(item, index) in aiCoreTechnology.descList" :key="index">• {{ item }}</p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="app4-meida">
                  <MediaSwiper :mediaList="aiCoreTechnology.image" :alt="aiCoreTechnology.title || ''"></MediaSwiper>
                </div>
              </Ani>
            </template>
          </li>
          <li>
            <template v-if="JSON.stringify(allData) !== '{}'">
              <Ani class="app4-item flex align-center justify-between">
                <div class="app4-text">
                  <div class="app4-tag font16">
                    <img v-if="allData.tagIcon" class="icon" :src="allData.tagIcon" alt="icon" />
                    <span class="text ellipsis">{{ allData.tag }}</span>
                  </div>
                  <div class="app4-con">
                    <h3 class="app4-title font24" :class="locale == 'en-US'?'':'ellipsis'">{{ allData.title }}</h3>
                    <div class="app4-info" :class="locale == 'en-US'?'':'MultiLine2'">
                      <div class="app4-des font16">
                        <p>{{ allData.desc }}</p>
                      </div>
                    </div>
                    <ul class="app4-list2 flex flex-wrap font16">
                      <li v-for="(item, index) in allData.dataList" :key="index">
                        <p>
                          <strong>{{ item.title }}</strong>
                        </p>
                        <p v-for="(subItem, subIndex) in item.descList" :key="subIndex">• {{ subItem }}</p>
                      </li>
                    </ul>
                  </div>
                  <div class="app4-tips flex-inline align-start" v-if="allData.tip">
                    <img class="icon" :src="allData.tipIcon" alt="" />
                    <span :class="locale == 'en-US'?'':'MultiLine1'">{{ allData.tip }}</span>
                  </div>
                </div>
                <div class="app4-meida width-100">
                  <MediaSwiper :mediaList="allData.indicatorImg" :alt="allData.title || ''"></MediaSwiper>
                </div>
              </Ani>
            </template>
          </li>
          <li>
            <template v-if="JSON.stringify(realTimeVis) !== '{}'">
              <Ani class="app4-item flex align-center justify-between">
                <div class="app4-text">
                  <div class="app4-tag font16">
                    <img v-if="realTimeVis.tagIcon" class="icon" :src="realTimeVis.tagIcon" alt="icon" />
                    <span class="text ellipsis">{{ realTimeVis.tag }}</span>
                  </div>
                  <div class="app4-con">
                    <h3 class="app4-title font24" :class="locale == 'en-US'?'':'ellipsis'">{{ realTimeVis.title }}</h3>
                    <div class="app4-info" :class="locale == 'en-US'?'':'MultiLine2'">
                      <div class="app4-des font16">
                        <p>
                          {{ realTimeVis.desc }}
                        </p>
                      </div>
                    </div>
                    <ul class="app4-list3 font16">
                      <li v-for="(item, index) in realTimeVis.indicators" :key="index">
                        <div class="app4-list3-icon flex-center">
                          <img :src="item.icon" alt="icon" />
                        </div>
                        <div class="app4-list3-text font16">
                          <h4 class="app4-list3-title font16 MultiLine1">{{ item.title }}</h4>
                          <p class="MultiLine2">{{ item.desc }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="app4-tips flex-inline align-start" v-if="realTimeVis.tip">
                    <img class="icon" :src="realTimeVis.tipIcon" alt="" />
                    <span :class="locale == 'en-US'?'':'MultiLine1'">{{ realTimeVis.tip }}</span>
                  </div>
                </div>
                <div class="app4-meida">
                  <MediaSwiper :mediaList="realTimeVis.image" :alt="realTimeVis.title || ''"></MediaSwiper>
                </div>
              </Ani>
            </template>
          </li>
          <li>
            <template v-if="JSON.stringify(safetyEscort) !== '{}'">
              <Ani class="app4-item flex align-center justify-between">
                <div class="app4-text">
                  <div class="app4-tag font16">
                    <img v-if="safetyEscort.tagIcon" class="icon" :src="safetyEscort.tagIcon" alt="icon" />
                    <span class="text ellipsis">{{ safetyEscort.tag }}</span>
                  </div>
                  <div class="app4-con">
                    <h3 class="app4-title font24" :class="locale == 'en-US'?'':'ellipsis'">{{ safetyEscort.title }}</h3>
                    <div class="app4-info" :class="locale == 'en-US'?'':'MultiLine2'">
                      <div class="app4-des font16">
                        <p>{{ safetyEscort.desc }}</p>
                      </div>
                    </div>
                    <ul class="app4-list2 flex flex-wrap font16">
                      <li v-for="(item, index) in safetyEscort.dataList" :key="index">
                        <p>
                          <strong>{{ item.title }}</strong>
                        </p>
                        <p v-for="(subItem, subIndex) in item.descList" :key="subIndex">• {{ subItem }}</p>
                      </li>
                    </ul>
                  </div>
                  <div class="app4-tips flex-inline align-start" v-if="safetyEscort.tip">
                    <img class="icon" :src="safetyEscort.tipIcon" alt="" />
                    <span :class="locale == 'en-US'?'':'MultiLine1'">{{ safetyEscort.tip }}</span>
                  </div>
                </div>
                <div class="app4-meida">
                  <ul class="app4-meida4 list-style">
                    <li v-for="(item, index) in safetyEscort.indicators" :key="index">
                      <div class="app4-item4">
                        <div class="app4-title4 ellipsis">
                          <img :src="item.icon" alt="icon" />
                          {{ item.title }}
                        </div>
                        <p class="MultiLine2">{{ item.desc }}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </Ani>
            </template>
          </li>
        </ul>
      </div>
    </div>
    <!-- 用户真实反馈 -->
    <UserReviews
      v-if="JSON.stringify(userReviews) !== '{}'"
      class="app-bg5"
      :heading="userReviews.title"
      :reviews="userReviews.dataList"
    ></UserReviews>
    <div class="app-bg app-bg6">
      <div class="wrap">
        <template v-if="JSON.stringify(dataQuality) !== '{}'">
          <Ani class="box-title text-center">
            <h2 class="box-h2 font36 color-f">{{ dataQuality.title }}</h2>
          </Ani>
          <Ani>
            <ul class="box1-list list-style flex justify-between font16 color-f text-center">
              <li v-for="(item, index) in dataQuality.dataList" :key="index">
                <div class="box1-num font18 no-wrap">
                  <strong class="font40">{{ item.count }}</strong>
                  {{ item.unit }}
                </div>
                <div class="box1-text">
                  <p>{{ item.title }}</p>
                </div>
              </li>
            </ul>
          </Ani>
        </template>
      </div>
    </div>

    <domesticApp
      v-if="JSON.stringify(download) !== '{}'"
      :heading="t('weather.downloadTile')"
      :appStore="download"
      :buryKey="{
        ios: 'Weather_APP_page_channel_Download_iOS',
        android: 'Weather_APP_page_channel_Download_Android',
        other: 'Weather_APP_page_channel_Download_else'
      }"
    ></domesticApp>
  </div>
</template>
<script setup lang="ts">
import { ref, reactive } from 'vue'
import useServerRequest from '@/composables/useServerRequest'
import type {
  configParams,
  configResponse,
  bannerConfig,
  AppStore,
  AppsConfig,
  DownloadApp,
  UserReviews,
  TrustUser,
  AuthCert,
  AiCoreTechnology,
  AllData,
  RealTimeVis,
  SafetyEscort,
  DataQuality
} from '~/types'
import { useI18n } from 'vue-i18n' // 导入 useI18n
const { locale, t } = useI18n() // 获取当前 i18n 语言（如 zh-CN/en-US）
import { useLocalePath, useRuntimeConfig } from '#imports'
const config = useRuntimeConfig()
const cmsurlStrategy = config?.public?.cmsStrategy
import { handleApiResponse, appDownload, getConfigDownloadApp } from '@/utils/utils'

const bannerImage = ref<string>(staticURL('/banner/application-banner.webp'))

const trackDownload = (downloadInfo: any, buryKey: any) => {
  findBuryKey(buryKey)
  appDownload(downloadInfo.link, downloadInfo.packageUrl, downloadInfo.type)
}

const status = ref<number>(0)
const infoParams = reactive<configParams>({
  pageCode: 'MOJI_WEATHER_APP'
})
const seo = ref<configResponse['pageValue']['seo']>({
  title: '',
  keywords: '',
  desc: ''
})
const bannerInfo = ref<bannerConfig>({})
const trustUser = ref<TrustUser>({})
const authCert = ref<AuthCert>({})
const coreFeature = ref<AuthCert>({})
const aiCoreTechnology = ref<AiCoreTechnology>({})
const allData = ref<AllData>({})
const realTimeVis = ref<RealTimeVis>({})
const safetyEscort = ref<SafetyEscort>({})
const userReviews = ref<UserReviews>({})
const dataQuality = ref<DataQuality>({})
const appStore = ref<AppStore>({})
const download = ref<DownloadApp>({})

const getInfo = async () => {
  try {
    const { data } = await useServerRequest<configResponse>('MOJI_WEATHER_APP', `${cmsurlStrategy}/getPageConfig`, {
      method: 'GET',
      params: infoParams,
      language: locale.value
    })

    const res = data?.value
    const result = handleApiResponse(res)
    if (!result.success) {
      status.value = result.status
      return
    }

    const getInfoData = data?.value?.data?.pageValue
    seo.value = getInfoData?.seo
    bannerInfo.value = getInfoData?.banner?.[0] || {}
    trustUser.value = getInfoData?.trustUser || {}
    authCert.value = getInfoData?.authCert || {}
    coreFeature.value = getInfoData?.coreFeature || {}
    aiCoreTechnology.value = getInfoData?.aiCoreTechnology || {}
    allData.value = getInfoData?.allData || {}
    realTimeVis.value = getInfoData?.realTimeVis || {}
    safetyEscort.value = getInfoData?.safetyEscort || {}
    userReviews.value = getInfoData?.userReviews || {}
    dataQuality.value = getInfoData?.dataQuality || {}
    console.log(getInfoData)
    console.log(trustUser.value)
    const apps = data?.value?.data?.apps as AppsConfig
    download.value = getConfigDownloadApp(['android', 'ios'], apps)
    //appStore.value = getConfigDownloadApp(['android', 'ios'], apps) || {}
  } catch (error) {}
}
getInfo()
useHead({
  title: () => seo?.value?.title || '', // 保持不变（已正确）
  meta: [
    {
      name: 'keywords',
      content: () => seo?.value?.keywords || '' // 改为函数形式！
    },
    {
      name: 'description',
      content: () => seo?.value?.desc || '' // 改为函数形式！（去掉多余的模板字符串）
    }
  ]
})
</script>
<style lang="scss" scoped>
@use '@/assets/css/weather.scss';
</style>
